export const TOKEN_KEY = 'authTrackingToken';

export const addTokenToStorage = token => {
  localStorage.setItem(TOKEN_KEY, token);
};

export const clearTokenToStorage = () => {
  localStorage.removeItem(TOKEN_KEY);
};

export const getToken = () => localStorage.getItem(TOKEN_KEY);
